module.exports = __webpack_public_path__ + "img/brunei.1d197411.svg";